import { createApp } from 'vue'
import { Quasar, Ripple, ClosePopup } from 'quasar';

import 'quasar/dist/quasar.css'
import '@quasar/extras/material-icons/material-icons.css'

import App from '../client/src/App.vue';
import '../client/src/css/tailwind.css';
import router from '../client/src/router';
import PrimeVue from 'primevue/config';
import { initializeAuth } from '../client/src/composables/useAuth';

// Initialize authentication state from sessionStorage
initializeAuth();

const myApp = createApp(App)

myApp.use(Quasar, {
	plugins: {},
	directives: {
		Ripple,
		ClosePopup,
	},
})
myApp.use(router);
myApp.use(PrimeVue);
myApp.mount('#app')
